export default __webpack_public_path__ + "static/initial-design-0905be049e95a36032c899e9cb7e76fc.webp";